// Copyright (c) 2021. Sendanor <info@sendanor.fi>. All rights reserved.

import React from 'react';
import './IFormView.scss';
import FormModel from "../../../../nor/ui/types/FormModel";
import Form, {FormProps} from "../../../../nor/ui/components/form/Form";
import FormWindowEventService, {
    FormWindowEventServiceDestructor,
    FormWindowEventServiceOnSetCancelCallback,
    FormWindowEventServiceOnSetModelCallback,
    FormWindowEventServiceOnSetSubmitCallback,
    FormWindowEventServiceOnSetValueCallback,
    FormWindowEventServiceOnUnsetCancelCallback,
    FormWindowEventServiceOnUnsetSubmitCallback
} from "../../../../services/FormWindowEventService";
import FormAppClassName from "../../../../constants/FormAppClassName";
import {FormValue} from "../../../../nor/ui/types/FormValue";
import LogService from "../../../../nor/ts/LogService";
import {FormWindowEventServiceEvent} from "../../../../services/types/FormWindowEventServiceEvent";
import {VoidCallback} from "../../../../nor/ts/interfaces/callbacks";

const LOG = LogService.createLogger('IFormView');

export interface IFormViewProps {

}

export interface IFormViewState {

    readonly model: FormModel;
    readonly value: FormValue;
    readonly hasSubmit : boolean;
    readonly hasCancel : boolean;

}

export class IFormView extends React.Component<IFormViewProps, IFormViewState> {

    private readonly _setModelCallback    : FormWindowEventServiceOnSetModelCallback;
    private readonly _setValueCallback    : FormWindowEventServiceOnSetValueCallback;
    private readonly _setSubmitCallback   : FormWindowEventServiceOnSetSubmitCallback;
    private readonly _setCancelCallback   : FormWindowEventServiceOnSetCancelCallback;
    private readonly _unsetSubmitCallback : FormWindowEventServiceOnUnsetSubmitCallback;
    private readonly _unsetCancelCallback : FormWindowEventServiceOnUnsetCancelCallback;
    private readonly _cancelCallback      : VoidCallback;
    private readonly _submitCallback      : VoidCallback;

    private _setModelListener    : FormWindowEventServiceDestructor | undefined;
    private _setValueListener    : FormWindowEventServiceDestructor | undefined;
    private _setSubmitListener   : FormWindowEventServiceDestructor | undefined;
    private _setCancelListener   : FormWindowEventServiceDestructor | undefined;
    private _unsetSubmitListener : FormWindowEventServiceDestructor | undefined;
    private _unsetCancelListener : FormWindowEventServiceDestructor | undefined;

    public constructor(props: IFormViewProps) {

        super(props);

        this.state = {
            model: {
                title: 'Title',
                items: []
            },
            value: {
            },
            hasCancel: false,
            hasSubmit: false
        };

        this._setModelCallback = this._onSetModel.bind(this);
        this._setValueCallback = this._onSetValue.bind(this);
        this._setSubmitCallback = this._onSetSubmit.bind(this);
        this._setCancelCallback = this._onSetCancel.bind(this);
        this._unsetSubmitCallback = this._onUnsetSubmit.bind(this);
        this._unsetCancelCallback = this._onUnsetCancel.bind(this);

        this._submitCallback = this._onSubmit.bind(this);
        this._cancelCallback = this._onCancel.bind(this);

    }

    public componentDidMount() {

        this._setModelListener    = FormWindowEventService.on(FormWindowEventService.Event.SET_MODEL, this._setModelCallback);
        this._setValueListener    = FormWindowEventService.on(FormWindowEventService.Event.SET_VALUE, this._setValueCallback);
        this._setSubmitListener   = FormWindowEventService.on(FormWindowEventService.Event.SET_SUBMIT, this._setSubmitCallback);
        this._setCancelListener   = FormWindowEventService.on(FormWindowEventService.Event.SET_CANCEL, this._setCancelCallback);
        this._unsetSubmitListener = FormWindowEventService.on(FormWindowEventService.Event.UNSET_SUBMIT, this._unsetSubmitCallback);
        this._unsetCancelListener = FormWindowEventService.on(FormWindowEventService.Event.UNSET_CANCEL, this._unsetCancelCallback);

    }

    public componentWillUnmount() {

        if(this._setModelListener) {
            this._setModelListener();
            this._setModelListener = undefined;
        }

        if(this._setValueListener) {
            this._setValueListener();
            this._setValueListener = undefined;
        }

    }

    public render () {

        const {
            model,
            value,
            hasSubmit,
            hasCancel
        } = this.state;

        let formProps : FormProps<FormValue> = {
            model: model,
            value: value
        };

        if (hasSubmit) {
            formProps = {...formProps, submit: this._submitCallback};
        }

        if (hasCancel) {
            formProps = {...formProps, cancel: this._cancelCallback};
        }

        return (
            <div className={FormAppClassName.I_FORM_VIEW}>

                <Form {...formProps} />

            </div>
        );

    }


    private _onSetModel (
        event  : FormWindowEventServiceEvent.SET_MODEL,
        model  : FormModel,
        origin : string
    ) {
        LOG.debug('_onSetModel: message origin: ', origin);
        this.setState({model: model});
    }

    private _onSetValue (
        event  : FormWindowEventServiceEvent.SET_VALUE,
        value  : FormValue,
        origin : string
    ) {
        LOG.debug('_onSetValue: message origin: ', origin);
        this.setState({value: value});
    }

    private _onSetSubmit (
        event  : FormWindowEventServiceEvent.SET_SUBMIT,
        origin : string
    ) {

        LOG.debug('_onSetSubmit: message origin: ', origin);

        this.setState({hasSubmit: true});

    }

    private _onSetCancel (
        event  : FormWindowEventServiceEvent.SET_CANCEL,
        origin : string
    ) {
        LOG.debug('_onSetCancel: message origin: ', origin);

        this.setState({hasCancel: true});

    }

    private _onUnsetSubmit (
        event  : FormWindowEventServiceEvent.UNSET_SUBMIT,
        origin : string
    ) {
        LOG.debug('_onUnsetSubmit: message origin: ', origin);

        this.setState({hasSubmit: false});

    }

    private _onUnsetCancel (
        event  : FormWindowEventServiceEvent.UNSET_CANCEL,
        origin : string
    ) {
        LOG.debug('_onUnsetCancel: message origin: ', origin);
        this.setState({hasCancel: false});
    }

    private _onSubmit () {
        LOG.debug('WOOT: on submit');
        FormWindowEventService.sendSubmitMessage(this.state.value);
    }

    private _onCancel () {
        LOG.debug('WOOT: on cancel');
        FormWindowEventService.sendCancelMessage();
    }

}

export default IFormView;
